import axios from "axios";
import {axiosCatchHandler} from "../sharedGlobal";

const SET_LOADING = 'SET_LOADING';
const SET_ERRORS = 'SET_ERRORS';
const SET_WEBSITE = 'SET_WEBSITE';
const SET_INDUSTRY = 'SET_INDUSTRY';
const SET_COUNTRY = 'SET_COUNTRY';
const SET_REGION = 'SET_REGION';
const SET_LOCATION = 'SET_LOCATION';
const SET_PRODUCTS = 'SET_PRODUCTS';

const state = {
    loading: false,
    errors: {},
    agencyProduct: {},
    localProduct: {},
    form: {
        website: '',
        industry: '',
        country: '',
        region: '',
        location: '',
    }
};

const getters = {
    loading: ({loading}) => loading,
    errors: ({errors}) => errors,
    website: ({form}) => form.website,
    industry: ({form}) => form.industry,
    country: ({form}) => form.country,
    region: ({form}) => form.region,
    location: ({form}) => form.location,
    agencyProduct: ({agencyProduct}) => agencyProduct,
    localProduct: ({localProduct}) => localProduct,
};

const actions = {
    validateWebsite: async ({commit}, website) => {
        commit(SET_LOADING, true);
        commit(SET_ERRORS, {});

        if (website !== '' && website === state.form.website) {
            commit(SET_LOADING, false);
            return;
        }

        try {
            await axios.post('/ajax/website/validate', {website: website});

            commit(SET_LOADING, false);
            commit(SET_WEBSITE, website);
        } catch (error) {
            axiosCatchHandler(error, () => {
            });

            commit(SET_ERRORS, {
                errors: error.response.data.errors,
            });

            commit(SET_LOADING, false);
        }
    },
    setStepTwo: async ({commit}, data) => {
        commit(SET_INDUSTRY, data.industry);
        commit(SET_COUNTRY, data.country);
        commit(SET_REGION, data.region);
        commit(SET_LOCATION, data.location);

        commit(SET_LOADING, false);
        commit(SET_ERRORS, {});
    },
    fetchLocations: async ({commit}, parentId) => {
        commit(SET_LOADING, true);

        const { data } = await axios.post('/ajax/keyword/regions', {parent: parentId});

        commit(SET_LOADING, false);
        return data;
    },
    create: async ({commit, dispatch }, planId) => {
        commit(SET_LOADING, true);
       try {
           const form = state.form;
           const { data } = await axios.post('/ajax/agency/website/store', {
               website: form.website,
               industry_gcid: form.industry,
               country_id: form.country,
               specific_location_id: form.location,
               plan: planId
           });

           window.location.href = data.redirectUrl;
       } catch (error) {
           axiosCatchHandler(error, () => {});

           if (error.response.status === 402) {
               const { paymentIntent } = error.response.data;

               commit(SET_LOADING, true);

               window.Stripe.confirmCardPayment(paymentIntent.clientSecret, {
                   payment_method: paymentIntent.paymentMethod,
               }).then((result) => {
                   if (result.error) {
                       axios.get('/stripe/payment-verification-failed');

                       Swal.fire({
                           icon: 'warning',
                           title: 'Add website failed',
                           html: 'We were unable to verify your payment for this website,<br>please try again later.',
                           didClose: function () {
                               window.location.reload();
                           }
                       });

                       commit(SET_LOADING, false);

                       return;
                   }

                   dispatch('create', planId);
               })
           }
       }
    },
    fetchProducts: async ({commit}) => {
        commit(SET_LOADING, true);

        try{
            const { data } = await axios.get('/ajax/agency/website/products');
            commit(SET_PRODUCTS, data);
        } catch (error) {
            axiosCatchHandler(error, () => {});
            commit(SET_LOADING, false);
        }

        commit(SET_LOADING, false);
    },
    setLoading: ({commit}, loading) => commit(SET_LOADING, loading),
    setErrors: ({commit}, errors) => commit(SET_ERRORS, errors),
};

const mutations = {
    [SET_LOADING](state, loading) {
        state.loading = loading;
    },
    [SET_ERRORS](state, errors) {
        state.errors = errors.errors ?? {};
    },
    [SET_WEBSITE](state, website) {
        state.form.website = website;
    },
    [SET_INDUSTRY](state, industry) {
        state.form.industry = industry;
    },
    [SET_COUNTRY](state, country) {
        state.form.country = country;
    },
    [SET_REGION](state, region) {
        state.form.region = region;
    },
    [SET_LOCATION](state, location) {
        state.form.location = location;
    },
    [SET_PRODUCTS](state, products) {
        const {agency, local} = products;

        state.agencyProduct = agency;
        state.localProduct = local;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
